module.exports = __webpack_public_path__ + "img/color-2@2x.d42a8cc.webp";